import { CartLinesUpdateEvent } from '@shopify/events';
import { morphSection } from '@theme/section-renderer';

const SECTION_ID = 'cart-drawer-section';

/**
 * Añade la variante seleccionada al carrito usando el mismo mecanismo AJAX
 * que cart-upsell.js (CartLinesUpdateEvent + morphSection).
 *
 * @param {HTMLButtonElement} button
 */
async function addCdrProduct(button) {
  const product = button.closest('[data-cdr-product]');
  if (!product) return;

  const select = /** @type {HTMLSelectElement | null} */ (
    product.querySelector('[data-cdr-variant-select]')
  );

  const variantId = select
    ? parseInt(select.value, 10)
    : parseInt(button.dataset.variantId ?? '0', 10);

  if (!variantId) return;

  button.disabled = true;
  const originalText = button.textContent.trim();
  button.textContent = '···';

  const deferredPromise = CartLinesUpdateEvent.createPromise();

  document.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      promise: deferredPromise.promise,
    })
  );

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: SECTION_ID,
        sections_url: window.location.pathname,
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.description ?? 'Error al añadir el producto');
    }

    const sectionHtml = data.sections?.[SECTION_ID];
    if (sectionHtml) {
      await morphSection(SECTION_ID, sectionHtml, { mode: 'hydration' });
    }

    deferredPromise.resolve({
      cart: data,
      sections: data.sections ?? {},
    });
  } catch (error) {
    console.error('[Cart Recomendados]', error);
    deferredPromise.reject(error);
    button.disabled = false;
    button.textContent = originalText;
  }
}

// Event delegation — funciona antes y después de re-renders del carrito.
document.addEventListener('click', (event) => {
  const btn = /** @type {HTMLButtonElement | null} */ (
    event.target instanceof Element ? event.target.closest('[data-cdr-add-btn]') : null
  );
  if (!btn) return;
  event.preventDefault();
  addCdrProduct(btn);
});
